export default __webpack_public_path__ + "d495bc045f08ea99ec79efbd6c974ba4.svg";